/** @format */

import React from "react";
import { Container } from "react-bootstrap";
import "./VideoSection.css";

const VideoSection = () => {
	return (
		<div className="video-section" id="video">
			<Container>
				<div className="video-wrapper">
					<video
						className="clinic-video"
						src="/docvideo.mp4?v=1" // Path to your video file in the public folder
						controls
						poster="/docvideo.png" // Optional poster image for the video
					>
						Your browser does not support the video tag.
					</video>
				</div>
			</Container>
		</div>
	);
};

export default VideoSection;
